























import PackBlock from './Pack.vue';
import { SubscriptionPack } from '@/types/models/subscriptionTypes';
import { Vue, Component, Prop } from 'vue-property-decorator';
import AddIcon from '@/components/icons/Add.vue';

@Component({
    components: {
        AddIcon,
        PackBlock,
    }
})
export default class SubscriptionPacksComponent extends Vue {
    @Prop() packs!: SubscriptionPack[];
    @Prop() model!: Record<string, any>;
    @Prop({ default: true }) isEditable!: boolean;
    @Prop({ default: true }) isAdd!: boolean;

    addPack() {
        this.packs.push({
            id: 0,
            limit: 1,
            specializations: [],
            medicalServiceTypes: [],
        });
    }

    emitAdd(data: { limit: number; specializations: any[]; medicalServiceTypes: any[] }) {
        this.$emit('add', data);
    }

    emitSave(data: { limit: number; specializations: any[]; medicalServiceTypes: any[] }) {
        this.$emit('save', data);
    }

    emitRemove(id: number) {
        this.$emit('remove', id);
    }
}
